module.exports = __webpack_public_path__ + "6d88c3bf718610b27e9f8b703ef72e40.pdf";